import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { EndocrineOestrogenDiagramContent } from "./EndocrineOestrogenDiagram";
import { EndocrineOestrogenKeyContent } from "./EndocrineOestrogenKey";

const SvgEndocrineOestrogenDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1540}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 914, 1192)}
      viewBox={diagramOnly ? "0 204 1540 914" : "0 0 1540 1192"}
    >
      <g id="endocrine-oestrogen-diagram+key" clipPath="url(#clip0_18293_224291)">
        <rect width={1540} height={diagramOnly ? 914 : 1192} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <EndocrineOestrogenKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <EndocrineOestrogenDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18293_224291">
          <rect width={1540} height={1192} fill="white" />
        </clipPath>
        <clipPath id="clip1_18293_224291">
          <rect width={1540} height={914} fill="white" transform="translate(0 204)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgEndocrineOestrogenDiagramKey;
